<template>
  <div>
    <PayDialog
      v-if="payDialogVisible"
      :dialog-visible.sync="payDialogVisible"
      :data="payDialogData"
      @submit="handlePaySubmit"
    />
    <el-dialog :title="rechargeTitle" :visible.sync="rechargeVisible" width="1020px" custom-class="dialog-table">
      <Recharge
        v-if="rechargeVisible"
        ref="recharge"
        :balances="balances"
        :mode="mode"
        :submit-handler="handleBankSubmit"
        @success="handleRechargeSuccess"
        @close="handleRechargeClose"
      />
    </el-dialog>
    <el-dialog
      :visible.sync="successVisible"
      :close-on-click-modal="false"
      :modal="false"
      center
      custom-class="dialog-zindex"
      @closed="successMode = ''"
    >
      <div class="msgBox">
        <div class="msgBox_top">
          <img src="../../assets/images/recharge/icon_success.png" alt="" />
          <span class="msgBox_title">{{ $t('recharge.submitSuccessTip') }}</span>
        </div>
        <div class="msgBox_content">
          <p>
            {{ successMode === 'pay' ? $t('recharge.payAmount') : $t('recharge.rechargeAmount') }}:
            <span class="msgBox_amount">{{ '\u00A5' + successAmount }}</span>
          </p>
          <p>
            {{ $t('recharge.submitTime') }}:
            <span class="msgBox_time">{{ successTime | dateFormatToSecond }}</span>
          </p>
        </div>
      </div>
      <span v-if="successMode !== 'pay'" slot="footer" class="dialog-footer">
        <el-button type="primary" @click="$emit('view-recharge-log')">{{ $t('recharge.viewRechargeLog') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import PayDialog from './index.vue'
import Recharge from '../recharge/Recharge.vue'

const defaultBalances = () => ({
  balance: 0,
  tradeNo: '',
  payType: '',
  balanceMoney: 0,
  money: 0
})

export default {
  name: 'PayRechargeDialog',
  components: { PayDialog, Recharge },
  props: {
    title: {
      type: String,
      default: ''
    },
    bankSubmitHandler: {
      type: Function,
      default: null
    }
  },
  data() {
    return {
      payDialogVisible: false,
      payDialogData: {},
      paySubmitData: {},
      rechargeVisible: false,
      balances: defaultBalances(),
      mode: '',
      pendingClose: null,
      successVisible: false,
      successMode: '',
      successAmount: 0,
      successTime: ''
    }
  },
  computed: {
    rechargeTitle() {
      return this.title || this.$t('fba.pay')
    }
  },
  methods: {
    openPayDialog({ data = {}, closeDetail = null } = {}) {
      this.payDialogData = data
      this.pendingClose = closeDetail
      this.payDialogVisible = true
    },
    closePending() {
      if (this.pendingClose) {
        this.pendingClose()
        this.pendingClose = null
      }
    },
    handlePaySubmit(payMethod, payData) {
      if (payMethod === 0) {
        this.closePending()
        this.$emit('balance-pay', { data: this.payDialogData, payData })
        return
      }
      if (payMethod === 1) {
        this.closePending()
        this.$emit('paypal-success', { data: this.payDialogData, payData })
        return
      }
      if (payMethod === 2) {
        this.openRecharge(payData)
      }
    },
    openRecharge(data = {}) {
      const { payMoney, balanceMoney, payType, money } = data
      this.paySubmitData = data
      this.mode = 'pay'
      this.balances = {
        balance: payMoney,
        tradeNo: this.payDialogData.tradingNo || '',
        balanceMoney,
        payType,
        money
      }
      this.rechargeVisible = true
    },
    handleBankSubmit(payload) {
      if (!this.bankSubmitHandler) {
        return Promise.reject(new Error('Missing bankSubmitHandler'))
      }
      return this.bankSubmitHandler({
        ...payload,
        payDialogData: this.payDialogData,
        paySubmitData: this.paySubmitData
      })
    },
    handleRechargeSuccess(payload) {
      this.closePending()
      this.successMode = this.mode
      const fallbackAmount = this.$refs.recharge && this.$refs.recharge.chargeForm
        ? this.$refs.recharge.chargeForm.money
        : 0
      this.clearRecharge()
      this.successVisible = true
      if (payload && payload.amount !== undefined && payload.amount !== null) {
        this.successAmount = payload.amount
      } else {
        this.successAmount = fallbackAmount
      }
      this.successTime = (payload && payload.time) ? payload.time : Date.now()
      this.$emit('success', payload)
    },
    clearRecharge() {
      this.rechargeVisible = false
      this.balances = defaultBalances()
      this.paySubmitData = {}
      this.mode = ''
    },
    handleRechargeClose() {
      this.pendingClose = null
      this.clearRecharge()
    }
  }
}
</script>

<style lang="less" scoped>
/deep/ .dialog-table .lx-flex-row-between {
  display: none !important;
}

/deep/ .dialog-table .notice {
  display: none !important;
}

/deep/ .dialog-table .el-dialog__title {
  color: red;
}

.msgBox {
  width: 80%;
  margin: 0 auto;
}

.msgBox .msgBox_top {
  display: flex;
  justify-content: center;
}

.msgBox .msgBox_top img {
  display: inline-block;
  width: 48px;
  height: 48px;
  margin-right: 22px;
}

.msgBox .msgBox_top span {
  display: inline-block;
  text-align: center;
  font-size: 24px;
  color: #9da4c3;
  font-family: Microsoft YaHei;
  font-weight: 400;
}

.msgBox_content {
  margin-top: 47px;
  margin-bottom: 36px;
  width: 100%;
  height: 15px;
  text-align: center;
}

.msgBox_content p {
  display: inline-block;
  color: #9da4c3;
  font-size: 14px;
  margin-right: 20px;
}

.msgBox_content span {
  display: inline;
  color: inherit;
  font-size: 14px;
}

.msgBox_amount {
  color: #3a4255;
}

.msgBox_time {
  color: #9da4c3;
}
</style>
